"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossiblePropertyMortgageSchema = void 0;
const zod_1 = require("zod");
const MortgageType_1 = require("../enums/MortgageType");
const constants_1 = require("../constants");
const Address_1 = require("./Address");
exports.impossiblePropertyMortgageSchema = zod_1.z.object({
    type: zod_1.z.optional(zod_1.z.nativeEnum(MortgageType_1.MortgageType)),
    loanNumber: constants_1.defaultOptionalString,
    lienHolder: constants_1.defaultOptionalString,
    lienHolderAddress: zod_1.z.optional(Address_1.impossibleAddressSchema),
    lienHolderAddressRaw: zod_1.z.optional(zod_1.z.string().min(constants_1.MIN_DEFAULT_STRING_LENGTH).max(128).regex(constants_1.REGEX.defaultString)),
}).strict();
